export const trackEvent = event => {
	// console.log('gtm:event', event);
	dataLayer.push({ event });
}

export const trackScreen = screenName => {
	// console.log('trackingScreen', screenName);
	ga('send', 'screenview', { screenName });
}

export const trackButtonClick = event => {
	// console.log('trackButtonClick', event);
	ga('send', 'event', 'Button', 'click', event);
}


// WEBPACK FOOTER //
// ./utils/tracking.js